import {createAction, props} from '@ngrx/store';
import {Serializer, Serializers} from "../../interfaces/serializer";
import {DataSource} from "../../interfaces/data-source";
import {ActionCreator, TypedAction} from '@ngrx/store/src/models';
import {DimensionComponentObjects} from '../../classes/dimension-component-object';
import {MetricComponentObjects} from '../../classes/metric-component-object';

export const loadDataSourcesUsage = createAction('[DATA_SOURCES_USAGE] LOAD');
export const loadDataSourcesUsageSuccess = createAction('[DATA_SOURCES_USAGE] LOAD_SUCCESS',  props<{ dataSources: Serializers<DataSource> }>());

export const updateDataSourceUsage = createAction('[DATA_SOURCES_USAGE] UPDATE', props<{ dataSource: Serializer<DataSource>, update: Partial<DataSource> }>());
export const updateDataSourceUsageSuccess = createAction('[DATA_SOURCES_USAGE] UPDATE_SUCCESS', props<{ dataSource: Serializer<DataSource> }>());
export const updateDataSourceUsageFailure = createAction('[DATA_SOURCES_USAGE] UPDATE_FAILURE');

export const updateDataSourceState = createAction('[DATA_SOURCES_USAGE] UPDATE_DATA_SOURCE_STATE', props<{ dataSource: Serializer<DataSource> }>());

export const launchImportDataSourcesUsage = createAction('[DATA_SOURCES_USAGE] LAUNCH_IMPORT', props<{
  dataSourceUsage: Serializer<DataSource>,
  period: any,
  onlyAttrib: boolean,
  allData: boolean
}>());

export const launchImportDataSourcesUsageSuccess = createAction('[DATA_SOURCES_USAGE] LAUNCH_IMPORT_SUCCESS');

export const initializeDataSourcesUsage: ActionCreator<'[DATA_SOURCES_USAGE] Initialize', () => TypedAction<'[DATA_SOURCES_USAGE] Initialize'>> = createAction('[DATA_SOURCES_USAGE] Initialize');

export const initializeDataSourcesUsageDimensionsSuccess: ActionCreator<
  '[DATA_SOURCES_USAGE] Initialize dimensions success',
  (props: { dimensions: DimensionComponentObjects }) => TypedAction<'[DATA_SOURCES_USAGE] Initialize dimensions success'> & { dimensions: DimensionComponentObjects }
> = createAction('[DATA_SOURCES_USAGE] Initialize dimensions success', props<{ dimensions: DimensionComponentObjects }>());

export const initializeDataSourcesUsageMetricsSuccess: ActionCreator<
  '[DATA_SOURCES_USAGE] Initialize metrics success',
  (props: { metrics: MetricComponentObjects }) => TypedAction<'[DATA_SOURCES_USAGE] Initialize metrics success'> & { metrics: MetricComponentObjects }
> = createAction('[DATA_SOURCES_USAGE] Initialize metrics success', props<{ metrics: MetricComponentObjects }>());
